import CustomToast from "../../../utils/CustomToast";
import * as TYPE from "../ActionConstants";
import ApiClient from "../../../apiClient";
import { BASE_URL, USER } from "../../../constant/apiEndPoint";

export const loadingToggleAction = (dispatch, status) => {
  return dispatch({
    type: TYPE.IS_FETCHING,
    payload: status,
  });
};

export const loginAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${USER.login}`, payload, false)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        saveTokenInLocalStorage(response.data);
        dispatch({
          type: TYPE.USER_LOGIN_SUCCESS,
          payload: response.data.result.data,
        });
        // CustomToast({
        //   type: "success",
        //   message: response.data.result.message,
        //   options: { autoClose: 3000, position: "top-center" },
        // });
        setTimeout(() => {
          navigate("/dashboard");
      }, 0);
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 401) {
          dispatch(loginFailedAction(error?.data?.result?.message));
          CustomToast({
            type: "error",
            message: error?.data?.result?.message,
            options: { autoClose: 1000, position: "top-center" },
          });
        } else {
          CustomToast({
            type: "error",
            message: error?.data?.result?.message,
            options: { autoClose: 1000, position: "top-center" },
          });
        }
      });
  };
};

export const logoutAction = (navigate, pathaname) => {
  localStorage.removeItem("userDetails");
  localStorage.removeItem("sessionToken");
  localStorage.clear();

 const allowedRoutes = ["/forgot-password", "/otp-varification", "/update-password", "/delete-account", "/privacyAndPolicy"]

 if(allowedRoutes.includes(pathaname)){
  return {
    type: TYPE.USER_LOGOUT,
  };
 }

  navigate("/login");
  return {
    type: TYPE.USER_LOGOUT,
  };
};

export const getOTPAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${USER.getOtp}`, payload, false)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        CustomToast({
          type: "success",
          message: response.data.result.message,
          options: { autoClose: 5000, position: "top-center" },
        });
        navigate("/otp-varification");
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const validateOTPAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${USER.validateOtp}`, payload)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        sessionStorage.setItem("temp_token", response.data.result.data.temp_token);
        CustomToast({
          type: "success",
          message: response.data.result.message,
          options: { autoClose: 5000, position: "top-center" },
        });
        navigate("/update-password");
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const updatePasswordAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${USER.updatePassword}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        CustomToast({
          type: "success",
          message: response.data.result.message,
          options: { autoClose: 5000, position: "top-center" },
        });
        sessionStorage.clear();
        navigate("/login");
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        dispatch(loginFailedAction(error?.data?.result?.message));
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const resetPasswordAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${USER.RESET_PASSWORD}`, payload, true)
      .then((response) => {
        // debugger;
        // loadingToggleAction(dispatch, false);
        CustomToast({
          type: "success",
          message: response.data.result.message,
          options: { autoClose: 5000, position: "top-center" },
        });
        // sessionStorage.clear();
        // window.location.reload();
        navigate("/dashboard");
      })
      .catch((error) => {
        // debugger;
        if (error.status === 422) {
          CustomToast({
            type: "error",
            message: "Current Password is incorrect",
            options: { autoClose: 5000, position: "top-center" },
          });
          return;
        }
        // loadingToggleAction(dispatch, false);
        // dispatch(loginFailedAction( error?.data?.result?.message));
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const loginFailedAction = (data) => {
  return {
    type: TYPE.USER_LOGIN_FAILED,
    payload: data,
  };
};

export const loginSuccessAction = (data) => {
  return {
    type: TYPE.USER_LOGIN_SUCCESS,
    payload: data?.result?.data,
  };
};

export const userLogoutAction = (navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.put(`${BASE_URL}${USER.userLogout}`, {}, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        CustomToast({
          type: "success",
          message: "User logged out successfully",
          options: { autoClose: 5000, position: "top-center" },
        });
        dispatch({ type: TYPE.USER_LOGOUT, payload: {} });
        localStorage.removeItem("userDetails");
        localStorage.removeItem("sessionToken");
        localStorage.clear();
        //navigate("/login");
        window.location.reload();
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        dispatch({ type: TYPE.USER_LOGOUT, payload: {} });
        localStorage.removeItem("userDetails");
        localStorage.removeItem("sessionToken");
        localStorage.clear();
        // navigate("/login");
        window.location.reload();
      });
  };
};

export const saveTokenInLocalStorage = (tokenDetails) => {
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails.result.data));
  localStorage.setItem("userRole", tokenDetails.result.data.role_name);
  localStorage.setItem("sessionToken", tokenDetails.result.data.session);
};

export const checkAutoLogin = (dispatch, navigate, pathaname) => {
  const tokenDetailsString = localStorage.getItem("userDetails");
  let tokenDetails = "";
  if (!tokenDetailsString) {
    dispatch(logoutAction(navigate, pathaname));
    return;
  }
  dispatch(loginSuccessAction(tokenDetails));
};

export const checkSession = (dispatch, navigate) => {
  dispatch(logoutAction(navigate));
  return;
};
